'use client';

import { Button } from '@shared/components/shadcn';
import { useNavigateBack } from '@shared/hooks';
import { LeftUpArrow } from '@shared/icons';
import { ROUTES } from '@shared/utils';
import type { ComponentProps } from 'react';

type UpArrowButtonProps = ComponentProps<typeof Button> & {
  ariaLabel: string;
};

function UpArrowButton({ ariaLabel, ...props }: UpArrowButtonProps) {
  const { navigateBack } = useNavigateBack({ fallbackUrl: ROUTES.HOME });
  return (
    <Button size="icon-m" variant="secondary" aria-label={ariaLabel} onClick={navigateBack} {...props}>
      <LeftUpArrow data-testid="up-arrow-link-icon" size="small" aria-hidden="true" />
    </Button>
  );
}

export { UpArrowButton };
